function ReplaceAll(str, searchStr, replaceStr) {
    return str.split(searchStr).join(replaceStr);
}
export default ReplaceAll;
 
 
 